<h2 class="mat-h2" mat-dialog-title>{{data.header}}</h2>
<mat-dialog-content>
  <mat-divider></mat-divider>
  <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="white" mat-button [mat-dialog-close]="false">{{data.cancelButtonText }}</button>
  <button mat-raised-button [color]="data.confirmButtonColor ?? 'primary'" [mat-dialog-close]="true" cdkFocusInitial>{{data.confirmButtonText}}</button>
</mat-dialog-actions>
